import React, { useEffect } from 'react'
import Bugsnag, { type NotifiableError, type Client } from '@bugsnag/browser'
import { get } from 'lodash'
import { getEnv } from '@adsk/acs-sc-web-platform-api'

interface MetaDataType {
	componentName?: string
	componentVersion?: string
	message: string
}

let NapiBugsnag: Client | null = null

const BugsnagNotify = (
	event: NotifiableError,
	metaData?: MetaDataType,
	retry?: boolean
): void => {
	if (NapiBugsnag != null) {
		NapiBugsnag.notify(event, (event) => {
			if (metaData != null) {
				event.addMetadata('info', metaData)
			}
		})
	} else if (retry !== false) {
		console.warn('Bugsnag has not started yet. Retrying in 1 second')
		setTimeout(() => {
			BugsnagNotify(event, metaData, false)
		}, 1e3)
	} else {
		console.error('Bugsnag has not started after retrying.')
	}
}

const withBugsnag = (
	Component: JSX.ElementType,
	componentName?: string,
	componentVersion?: string
) => {
	return function BugsnagHOC(props: any): JSX.Element {
		const bugsnagClientId = get(props, ['config', 'BUGSNAG_CLIENT_ID'], '')
		useEffect(() => {
			if (bugsnagClientId !== '' && NapiBugsnag === null) {
				NapiBugsnag = Bugsnag.createClient({
					apiKey: props.config.BUGSNAG_CLIENT_ID,
					releaseStage: getEnv() ?? 'development',
					autoDetectErrors: false,
					autoTrackSessions: false,
					onError: (event) => {
						const ERROR_LOG_PREFIX = `NAPI-Component: - ${
							componentName ?? ''
						} - ${componentVersion ?? ''} - `
						event.errors.map((err) => {
							err.errorMessage = `${ERROR_LOG_PREFIX} ${err.errorMessage}`
							return err
						})
					},
				})
			}
		}, [bugsnagClientId])
		return <Component {...props} />
	}
}
export default withBugsnag

export { BugsnagNotify }
